var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrenchFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 577.8",
    style: {
      enableBackground: "new 0 0 800 577.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ED2939;}\n\t.st1{fill:#002495;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M800,488.9c0,49.1-39.8,88.9-88.9,88.9H533.3V0h177.8C760.2,0,800,39.8,800,88.9V488.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.9,0C39.8,0,0,39.8,0,88.9v400c0,49.1,39.8,88.9,88.9,88.9h177.8V0H88.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M266.7,0h266.7v577.8H266.7V0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrenchFlag);
export default __webpack_public_path__ + "static/media/french_flag.7aede114ad944ddb82224271921aede4.svg";
export { ForwardRef as ReactComponent };